import React, { Component, Fragment } from "react";
import '../css/mapbox-gl.css';
import ReactMapGL, { Layer, Marker, Popup, NavigationControl } from "@urbica/react-map-gl";
import { Source } from "@urbica/react-map-gl";
import GlobalEvents from '../utils/global-events'
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import 'mapbox-gl/dist/mapbox-gl.css';
import Highcharts from "highcharts";
import Legend from '../components/Legends';
import SimpleAppBar from '../components/Bar';
import Selector from '../components/Selectors';
//import TempGraph from '../components/TemperatureTrendMap';
import HighchartsReact from 'highcharts-react-official';

let barChartColor = ["#2f32d1", "#EFE093", "#E1B675", "#DFA58B", "#D8CFAB", "#A7A19E", "#D3DB8D"];

let options = {
    chart: {
        type: 'item',
        backgroundColor: 'transparent',
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: '65%',

    },
    legend: {
        layout: 'horizontal',

        itemStyle: {
            fontSize: '8px',
            color: '#666666'
        },
        y: 10
    },
    title: {
        text: `Consumption % by Brand in`,
        style: {
            fontSize: '15px',
            fontWeight: 'bold',

        }
    },
    tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    credits: {
        enabled: false
    },
    plotOptions: {
        pie: {
            showInLegend: true,
            colors: ['#F7DA65', '#4DB286'],
            dataLabels: {
                connectorWidth: 0,
                enabled: true,
                distance: "-22%",
                format: '{point.y}%',
                style: {
                    fontWeight: '1px',
                    color: 'black',
                    fontSize: '8.5px',
                    // fontFamily: 'Roboto',
                    textOutline: '0px'

                }
            },
            startAngle: -90,
            endAngle: 90,
            center: ['50%', '30'],
            size: '120',
            borderWidth: 0,
        }
    },
    series: [{
        animation: false,
        type: 'pie',
        name: 'Market share',
        innerSize: '50%',
        data: [
            ["Your Brand", 62],
            ["Competitors", 38]
        ]
    }]
}

const config = require('../utils/config')
var max_count = 0;
var max_count_msa = 0;
var selected = "Eat"


const selected_mode_items = [
    {
        label: "Tick",
        value: "tick"
    },
    {
        label: "Cumulative",
        value: "cumulative"
    }
];

const selected_layer_items = [
    {
        label: "MSA",
        value: "msa"
    },
    {
        label: "ZIP",
        value: "zip"
    }
];

const selected_state_items = [
    {
        label: "Your Brand",
        value: "YourBrand"
    },
    {
        label: "Competitors",
        value: "Competitors"
    }
]

const styles = theme => ({
    root: {
        display: 'flex',
        width: "100%",
        height: "100%",
        padding: "8px",
    },
    formControl: {
        margin: "10px",
        padding: "8px",
        width: "120px",
        top: "10px",
        left: "10px"
    },
    legendPaper: {
        zIndex: 1,
        backgroundColor: theme.palette.background.paper,
        margin: "5px",
        padding: "2px",

    },
    listIcon: {
        marginRight: "0px"
    },
    stateSelectorPaper: {
        position: "absolute",
        zIndex: 1,
        backgroundColor: theme.palette.background.paper,
        top: "10px",
        left: "10px"
    },
    zoomLevelSelectorPaper: {
        position: "absolute",
        zIndex: 1,
        backgroundColor: theme.palette.background.paper,
        top: "48%",
        left: "10px"
    },
    listItem: {
        paddingTop: "2px",
        paddingBottom: "2px"
    },
    dropDown: {
        marginTop: "25px !important"
    },
    inputLabel: {
        fontSize: "20px"
    }
});

class CountryView extends Component {


    state = {
        dummy_state: false,
        clicked_state: "",
        clicked_zip: "",
        clicked_msa: "",
        showPopup: false, // Flag to display popup on statelayer
        showPopupZ: false, // Flag to display popup on MSA and ZIP
        popupLatitude: 0,
        popupLongitude: 0,
        zpopupLatitude: 0,
        zpopupLongitude: 0,
        isLegendOpened: true,
        LegendIcon: "LegendOpen.svg",
        viewport: {
            width: this.props.width,
            height: this.props.height,
            latitude: this.props.latitude,
            longitude: this.props.longitude,
            zoom: this.props.zoom,
            pitch: this.props.pitch,
            minPitch: this.props.minPitch,
            maxPitch: this.props.maxPitch,
            center: this.props.center,
        },
        selected_layer: 'zip',
        mappings: {
            'eat': "Eat",
            'sleep': "Sleep",
            'drink': "Drink"
        },
        selected_mode: this.props.namespace === "openScenario" ? "cumulative" : 'tick',
        simstarted: false,
        selected_state: 0,
        thingsToSelect: {
            admin: [
                "Eat",
                "Drink",
                "Sleep"
            ],
            marketing: [
                "YourBrand",
                "Competitors"
            ]
        },
        geourl: this.props.geourl,
        listening: false,
        msadata: [
            {
                "MSA": "99999",
                "State": "Connecticut",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0
            }
        ],
        data: [
            {
                "Zip": "35801",
                "State": "Connecticut",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {
                    Competitor_1: 0,
                    Competitor_2: 0,
                    Competitor_3: 0,
                    YourBrand: 0
                },
                "temperature": 0
            },
            {
                "Zip": "99501",
                "State": "Florida",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {
                    Competitor_1: 0,
                    Competitor_2: 0,
                    Competitor_3: 0,
                    YourBrand: 0
                },
                "temperature": 0
            },
            {

                "Zip": "85001",
                "State": "Illinois",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {
                    Competitor_1: 0,
                    Competitor_2: 0,
                    Competitor_3: 0,
                    YourBrand: 0
                },
                "temperature": 0
            },
            {
                "Zip": "72201",
                "State": "Kentucky",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {
                    Competitor_1: 0,
                    Competitor_2: 0,
                    Competitor_3: 0,
                    YourBrand: 0
                },
                "temperature": 0
            },
            {
                "Zip": "94203",
                "State": "Michigan",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {
                    Competitor_1: 0,
                    Competitor_2: 0,
                    Competitor_3: 0,
                    YourBrand: 0
                },
                "temperature": 0
            },
            {
                "Zip": "90001",
                "State": "Minnesota",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {
                    Competitor_1: 0,
                    Competitor_2: 0,
                    Competitor_3: 0,
                    YourBrand: 0
                },
                "temperature": 0
            },
            {
                "Zip": "90209",
                "State": "New Jersey",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {
                    Competitor_1: 0,
                    Competitor_2: 0,
                    Competitor_3: 0,
                    YourBrand: 0
                },
                "temperature": 0
            },
            {
                "Zip": "80201",
                "State": "Pennsylvania",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {
                    Competitor_1: 0,
                    Competitor_2: 0,
                    Competitor_3: 0,
                    YourBrand: 0
                },
                "temperature": 0
            },
            {
                "Zip": "06101",
                "State": "Washington",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {
                    Competitor_1: 0,
                    Competitor_2: 0,
                    Competitor_3: 0,
                    YourBrand: 0
                },
                "temperature": 0
            },
            {
                "Zip": "19901",
                "State": "Wisconsin",
                "Eat": 0,
                "Drink": 0,
                "Sleep": 0,
                "YourBrand": 0,
                "Competitors": 0,
                "penetration": {
                    Competitor_1: 0,
                    Competitor_2: 0,
                    Competitor_3: 0,
                    YourBrand: 0
                },
                "temperature": 0
            }
        ],
        max_count: 10,
        brands: ['Your Brand', 'Competitor 1', 'Competitor 2', 'Competitor 3', 'Competitor 4'],
        barChartData: [10, 20, 30, 40, 50]
    };

    componentWillUnmount() {

        // this.props.unsubscribe_ns(this.props.ns_value, data => {
        // });
        // this.props.unsubscribe_ns(this.props.ns_value2, data => {
        // });
    }

    globeView = () => {
        document.getElementById("GoldenView").style.display = "none";
        document.getElementById("Icons").style.display = "none";
        document.getElementById('Switch').style.display = "none";
        GlobalEvents.trigger('showglobe')
    };

    OpenFamily = () => {
        this.refs.Marker.style = 'display : block'
    }

    zoomMap(temp) {

        var mapContext = this.refs.map._map;

        // var zoomLevel = mapContext.getZoom();

        if (temp === "in") {
            mapContext.zoomIn();
        } else {
            mapContext.zoomOut();
        }

        // mapContext.flyTo({
        //     center: [-95.13520931418606, 40.765982],
        //     zoom: zoomLevel,
        //     pitch: config[this.props.countryname].pitch,
        //     bearing: config[this.props.countryname].bearing,
        // })

    }

    subscribeToNS = () => {
        const self = this;
        this.props.subscribe_ns(this.props.ns_value, (data) => {
            self.setState({ data: data });
        });
        this.props.subscribe_ns(this.props.ns_value2, (data) => {
            self.setState({ msadata: data });
        });
        this.setState({ listening: true });
    }

    handleChange = event => {
        const self = this;
        selected = event.target.value
        if (!self.state.listening) {
            self.subscribeToNS();
        }

        self.setState({
            listening: true,
            selected_state: self.state.thingsToSelect[sessionStorage.getItem("tab")].indexOf(selected)
        });

    };

    handleChange2 = event => {
        this.setState({
            selected_mode: event.target.value
        })
        this.props.emit_data('map_onchange', { dataType: event.target.value })
    }

    handleRadioChange = event => {
        this.setState({
            selected_layer: event.target.value
        })
    };

    resetButtonClicked() {

        if (this.props.namespace === "openScenario") {
            sessionStorage.setItem("zoom", 3.8)
        }

        sessionStorage.setItem("zoom2", sessionStorage.getItem("zoom"))

        this.refs.Marker.style = 'display:none';

        this.refs.map._map.flyTo({
            center: [-95.13520931418606, 40.765982],
            // center: [sessionStorage.getItem("long"), sessionStorage.getItem("lat")],
            zoom: sessionStorage.getItem("zoom"),
            pitch: config[this.props.countryname].pitch,
            bearing: config[this.props.countryname].bearing,
        })
    }

    componentDidMount() {
        //    var expression_drink = ["match", ["get", "NAME10"]];
        //    var expression_zip = ["match", ["get", "ZCTA5CE10"]]
        var zoomLevel = this.refs.map._map.getZoom()
        // var zmlvl = this.refs.map._map.getZoom()
        // var pitch = this.refs.map._map.getPitch()

        GlobalEvents.on('resetMap', this.resetButtonClicked.bind(this))

        if (zoomLevel >= 5) {
            this.forceUpdate()
        }

        if (sessionStorage.getItem('simStarted') === "true") {
            if (!this.state.listening) {
                this.subscribeToNS();
            }
            this.setState({
                simstarted: true
            })
        } else {
            GlobalEvents.on('startsim', () => {
                if (!this.state.listening) {
                    this.subscribeToNS();
                }
            });
        }

        var mapglContext = this.refs.map._map;

        // Defining event listeners for displaying popup on map click for State, MSA and Zip layer
        mapglContext.on('click', 'statelayer', function (e) {
            var feature = e.lngLat;
            this.setState({
                clicked_state: e.features[0].properties['NAME10'],
                showPopup: true,
                popupLatitude: feature.lat,
                popupLongitude: feature.lng
            })
        }.bind(this));

        mapglContext.on('click', 'ziplayer', function (e) {
            var feature = e.lngLat;
            this.setState({
                clicked_zip: e.features[0].properties['ZCTA5CE10'],
                showPopupZ: true,
                zpopupLatitude: feature.lat,
                zpopupLongitude: feature.lng
            })


        }.bind(this));

        mapglContext.on('click', 'msalayer', function (e) {
            var feature = e.lngLat;
            this.setState({
                clicked_msa: e.features[0].properties['cbsafp'],
                showPopupZ: true,
                zpopupLatitude: feature.lat,
                zpopupLongitude: feature.lng
            })


        }.bind(this));

        // Event listener to make pop-up disappear on mouse move / zoom for MSA and State Layer

        ["mousemove", 'zoom'].forEach(event => {

            // mapglContext.on(event, 'statelayer', function (e) {
            //     if (this.state.showPopup === true) {
            //         this.setState({
            //             showPopup: false
            //         })
            //     }
            // }.bind(this));

            ['ziplayer', 'msalayer'].forEach(layer => {
                mapglContext.on(event, layer, function (e) {
                    if (this.state.showPopupZ === true) {
                        this.setState({
                            showPopupZ: false
                        })
                    }
                }.bind(this));
            })

        })


        GlobalEvents.on('Agentsdata', (data) => {
            this.setState({
                max_count: data
            })
        })

        GlobalEvents.on('simdata', (data) => {
            this.setState({
                data: data
            })
        })

        GlobalEvents.on('changeEgg', (data) => {
            this.refs.map._map.flyTo({
                center: [77.73886856940976, 12.984805277756749],
                zoom: 17.5,
                pitch: 56.5,
                bearing: -84.5,
            })
        })

        let zoomInitial = 3.3;

        GlobalEvents.trigger('connect_socket', this.props.namespace)
        GlobalEvents.on('tab_selected', this.changePlotOptions.bind(this))
        GlobalEvents.on('changegraph', this.simstatus.bind(this))
        if (this.props.namespace === 'openScenario') {
            GlobalEvents.trigger('triggerOpenScenarioSimulation')
            zoomInitial = 3.8;
            this.subscribeToNS();
        }

        this.refs.map._map.flyTo({
            center: [-95.13520931418606, 40.765982],
            zoom: zoomInitial,
            pitch: config[this.props.countryname].pitch,
            bearing: config[this.props.countryname].bearing,
        })
    }

    changePlotOptions(data) {
        sessionStorage.setItem("tab", (data === 0 ? "admin" : "marketing"));
    }

    simstatus(data) {
    }

    getLegendIcon() {
        if (this.state.isLegendOpened) {
            return "LegendClose.svg"
        } else {
            return "LegendOpen.svg"
        }
        // this.setState({LegendIcon: "LegendClose.svg"}) : this.setState({LegendIcon: "LegendOpen.svg"})
    }


    renderDonut(data) {
        var mapContext = this.refs.map._map;
        var zoomLevel = mapContext.getZoom();
        let height;
        let chartoptions = JSON.parse(JSON.stringify(options))
        chartoptions.series[0].data = data;

        if (zoomLevel < 5) {

            chartoptions.title.text = `Consumption %`
            chartoptions.legend.y = 5
            chartoptions.title.align = 'center'
            chartoptions.title.margin = 20
            if (this.state.selected_mode === "cumulative") {
                height = "170px"
            }
            else height = "150px"

            chartoptions.title.style = {
                "fill": "#484848",
                "fontWeight": 100,
                "fontSize": '12px'
            }
        } else {
            if (this.state.selected_layer === 'zip') {
                height = "150px"
                chartoptions.title.text = `Consumption % in ZIP ${this.state.clicked_zip}`
            } else if (this.state.selected_layer === 'msa') {
                height = "150px"
                chartoptions.title.text = `Consumption % in MSA ${this.state.clicked_msa}`
            }
            chartoptions.title.style.fontSize = "14px"

        }

        if (isNaN(chartoptions.series[0].data[0][1]) && isNaN(chartoptions.series[0].data[1][1])) {

            if (this.state.selected_mode === 'cumulative') {
                return (<div style={{ background: "transparent", fontWeight: "bold" }}>
                    NO CONSUMERS YET !
                    </div>
                )
            } else {
                return (<div style={{ background: "transparent", fontWeight: "bold" }}>
                    CURRENTLY NO CONSUMERS
                    </div>
                )
            }
        } else {

            return (
                <div style={{ width: "220px", height: height, background: "transparent" }}>
                    <HighchartsReact highcharts={Highcharts} options={chartoptions} />
                </div>
            )
        }


    }


    legendWidth = (width) => {
        let widthToSet = 115 + (width - 200) / 6;


        if (widthToSet > 220) {
            widthToSet = 220;
        } else if (widthToSet < 115) {
            widthToSet = 115;
        }

        return widthToSet.toString() + 'px';
    }

    getLegends(classes, keyName) {
        let legWidth = this.legendWidth(this.props.countryWidth);

        const nameToShow = keyName === "YourBrand" ? "Your Brand" : keyName;

        if (this.refs.map) {

            var abc = this.refs.map._map;
            const ticksToShow = 5;

            if (max_count < 10 && abc.getZoom() < 5) {
                return (
                    <Paper className="LegendBackground" elevation={1} style={{ width: legWidth }}>
                        <div>
                            <div className="LegendText">{`# of agents consuming ${nameToShow}`}</div>
                            <Legend width={this.props.countryWidth} colors={config[keyName]} maxCount={10}
                                ticks={ticksToShow} />
                        </div>
                    </Paper>
                );
            }

            if (max_count > 10 && abc.getZoom() < 5) {
                return (
                    <Paper className="LegendBackground" elevation={1} style={{ width: legWidth }}>
                        <div>
                            <div className="LegendText">{`# of agents consuming ${nameToShow}`}</div>
                            <Legend width={this.props.countryWidth} colors={config[keyName]}
                                maxCount={Math.ceil(1.20 * max_count)} ticks={ticksToShow} />
                        </div>
                    </Paper>
                );
            }

            if (max_count < 10 && abc.getZoom() >= 5 && this.state.selected_layer === 'zip') {
                return (
                    <Paper className="LegendBackground" elevation={1} style={{ width: legWidth }}>
                        <div>
                            <div className="LegendText">{`# of agents consuming ${nameToShow}`}</div>
                            <Legend width={this.props.countryWidth} colors={config[keyName]} maxCount={10}
                                ticks={ticksToShow} />
                        </div>
                    </Paper>
                );
            }

            if (max_count > 10 && abc.getZoom() >= 5 && this.state.selected_layer === 'zip') {
                return (
                    <Paper className="LegendBackground" elevation={1} style={{ width: legWidth }}>
                        <div>
                            <div className="LegendText">{`# of agents consuming ${nameToShow}`}</div>
                            <Legend width={this.props.countryWidth} colors={config[keyName]}
                                maxCount={Math.ceil(1.20 * max_count)} ticks={ticksToShow} />
                        </div>
                    </Paper>
                );
            }

            if (max_count_msa < 10 && this.state.selected_layer === 'msa' && abc.getZoom() >= 5) {
                return (
                    <Paper className="LegendBackground" elevation={1} style={{ width: legWidth }}>
                        <div>
                            <div className="LegendText">{`# of agents consuming ${nameToShow}`}</div>
                            <Legend width={this.props.countryWidth} colors={config[keyName]} maxCount={10}
                                ticks={ticksToShow} />
                        </div>
                    </Paper>
                );
            }

            if (max_count_msa > 10 && this.state.selected_layer === 'msa' && abc.getZoom() >= 5) {
                return (
                    <Paper className="LegendBackground" elevation={1} style={{ width: legWidth }}>
                        <div>
                            <div className="LegendText">{`# of agents consuming ${nameToShow}`}</div>
                            <Legend width={this.props.countryWidth} colors={config[keyName]}
                                maxCount={Math.ceil(1.20 * max_count_msa)} ticks={ticksToShow} />
                        </div>
                    </Paper>
                );
            }
        }

    };


    getDropdown(classes, label, values) {
        const self = this;

        return (
            <FormControl style={{ margin: 0 }} className={classes.formControl}>
                <InputLabel className={classes.inputLabel} shrink htmlFor="age-label-placeholder">
                    {label}
                </InputLabel>
                <Select
                    value={values[self.state.selected_state].value}
                    getDropdown onChange={self.handleChange}
                    input={<Input name={label} id="age-label-placeholder" />}
                    displayEmpty
                    name={label}
                    className={classes.dropDown}
                >
                    {values.map(valeOb => {
                        return (
                            <MenuItem value={valeOb.value}>{valeOb.label}</MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        );
    }

    mapOptionsCollapsed = (zoomLevel, classes) => {
        return (<React.Fragment>
            <Paper className="AppBarCollapsed"><Selector label='Aggregation Mode'
                defaultValue={this.state.selected_mode}
                items={selected_mode_items} action={this.handleChange2} />
            </Paper>

            {sessionStorage.getItem('simStarted') === "true" ?
                <div>

                    {
                        sessionStorage.getItem("tab") === 'admin' ?
                            this.getDropdown(classes, "Physiological Activity", [
                                {
                                    label: "Eat",
                                    value: "Eat"
                                },
                                {
                                    label: "Drink",
                                    value: "Drink"
                                },
                                {
                                    label: "Sleep",
                                    value: "Sleep"
                                }
                            ])
                            :
                            <Paper className="AppBarCollapsed"><Selector label='Consumption'
                                defaultValue="YourBrand"
                                items={selected_state_items}
                                action={this.handleChange} /> </Paper>

                    }
                </div>
                : null
            }

            {
                zoomLevel >= 5 ?
                    <Paper className="AppBarCollapsed"> <Selector label='Level'
                        defaultValue={this.state.selected_layer}
                        items={selected_layer_items}
                        action={this.handleRadioChange} /></Paper>
                    :
                    null
            }
        </React.Fragment>
        );
    }

    mapOptions = (zoomLevel, classes) => {
        return (<React.Fragment>
            <Selector
                label='Aggregation Mode'
                defaultValue={this.props.namespace === "openScenario" ? "cumulative" : this.state.selected_mode}
                items={selected_mode_items}
                action={this.handleChange2} />

            {sessionStorage.getItem('simStarted') === "true" ?
                <div>

                    {
                        sessionStorage.getItem("tab") === 'admin' ?
                            this.getDropdown(classes, "Physiological Activity", [
                                {
                                    label: "Eat",
                                    value: "Eat"
                                },
                                {
                                    label: "Drink",
                                    value: "Drink"
                                },
                                {
                                    label: "Sleep",
                                    value: "Sleep"
                                }
                            ])
                            :
                            <Selector label='Consumption' defaultValue="YourBrand" items={selected_state_items}
                                action={this.handleChange} />

                    }
                </div>
                : null
            }

            {
                zoomLevel >= 5 ?
                    <Selector label='Level' defaultValue={this.state.selected_layer} items={selected_layer_items}
                        action={this.handleRadioChange} />
                    :
                    null
            }
        </React.Fragment>
        );
    }

    putMapDropdowns = (zoomLevel, classes, countryWidth) => {

        if (countryWidth >= 500) {


            return (
                <div className="MapDropdowns WidthSetter" style={{
                    left: `${!this.props.hide === true && this.props.namespace === "simulation" ? "31%" : "1%"}`,
                    width: `${this.props.namespace === "simulation" ? this.props.countryWidth : this.props.countryWidth - 80}px`
                }}>
                    <SimpleAppBar id="AppBar">
                        {this.mapOptions(zoomLevel, classes)}
                    </SimpleAppBar>
                </div>
            );
        } else {
            return (
                <div
                    style={{ left: `${!this.props.hide === true && this.props.namespace === "simulation" ? "31%" : "1%"}` }}
                    className="MapDropdowns">
                    {this.mapOptionsCollapsed(zoomLevel, classes)}
                </div>
            );
        }
    }

    // loadTempGraph(){
    //     let selected_state_data = this.state.data.find(state => state.State === this.state.clicked_state)
    //     return( selected_state_data.temperature);
    // }

    kFormatter(num) {
        if (num >= 1000000000) {
            return (num / 1000000000).toFixed(2).replace(/\.0$/, '') + 'G';
        }
        if (num >= 1000000) {
            return (num / 1000000).toFixed(2).replace(/\.0$/, '') + 'M';
        }
        if (num >= 1000) {
            return (num / 1000).toFixed(2).replace(/\.0$/, '') + 'K';
        }
        return num;
    }

    loadBarGraph() {

        let selected_state_data = this.state.data.find(state => state.State === this.state.clicked_state)

        let rqdData = selected_state_data.penetration

        if (rqdData !== undefined) {

            let numAgents = sessionStorage.getItem("namespace") === "simulation" ? parseInt(sessionStorage.getItem("no_of_agents")) : parseInt(JSON.parse(sessionStorage.getItem("scenarioDetail"))[0].numAgents)
            numAgents = (isNaN(numAgents)) ? 5000 : numAgents

            let ordered = {}

            Object.keys(rqdData).sort().forEach(function (key) {
                ordered[key] = rqdData[key];
            });

            let data2 = {}

            if (ordered.YourBrand) {

                data2["YourBrand"] = ordered.YourBrand
                delete ordered.YourBrand
                data2 = { ...data2, ...ordered }

            }
            else {
                data2["YourBrand"] = 0
                data2 = { ...data2, ...ordered }
            }

            let data = Object.values(data2)

            let dataGr = data.map(elem => parseFloat((elem * 100 / data.reduce((a, b) => { return a + b }, 0)).toFixed(1)))

            let compList = Object.keys(data2).filter(data => data !== "YourBrand")

            let penetrationData = this.state.data.map(stateData => stateData.penetration)

            let competitor_National_Penetration_Array = []

            for (let i in compList) {
                competitor_National_Penetration_Array.push(
                    penetrationData.map(elem => elem[compList[i]] ? elem[compList[i]] : 0).reduce((a, b) => a + b)
                )
            }

            let your_Brand_National_penetration = penetrationData.map(elem => elem.YourBrand ? elem.YourBrand : 0).reduce((a, b) => a + b)

            const chartoptions = {
                chart: {
                    type: 'bar',
                    height: '65%',
                },
                title: {
                    align: "center",
                    text: 'Brand Penetration %',
                    margin: 0,
                    style: {
                        fontSize: '12px'
                    }
                },
                subtitle: {
                    text: 'Values in parenthesis - Penetration indexed against National',
                    align: 'center',
                    y: 10,
                    verticalAlign: 'bottom',
                    style: {
                        color: '#464646',
                        fontSize: '9.5px',
                        fontWeight: '400',
                        // lineHeight: '8px'
                    }
                },
                xAxis: {
                    categories: Object.keys(data2),
                    title: {
                        text: null
                    },
                    lineWidth: 0
                },
                legend: {
                    enabled: false
                },
                yAxis: {
                    visible: false,
                },
                tooltip: {
                    valueSuffix: ' %'
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true
                        },
                    }
                },
                credits: {
                    enabled: false
                },
                series: [{
                    animation: false,
                    name: 'Brand Penetration',
                    data: dataGr.map((data, index) => ({ y: data, color: barChartColor[index] })),
                    dataLabels: {
                        formatter: function () {

                            function findVal(x) {
                                if (x === "YourBrand") {
                                    return your_Brand_National_penetration
                                }

                                else if (x === "Competitor_1") {
                                    return competitor_National_Penetration_Array[0]
                                }
                                else if (x === "Competitor_2") {
                                    return competitor_National_Penetration_Array[1]
                                }
                                else if (x === "Competitor_3") {
                                    return competitor_National_Penetration_Array[2]
                                }
                                else if (x === "Competitor_4") {
                                    return competitor_National_Penetration_Array[3]
                                }
                                else {
                                    return competitor_National_Penetration_Array[4]
                                }
                            }

                            return `${Highcharts.numberFormat(this.y, 0)}`
                                + ` (${(((this.y / dataGr.reduce((a, b) => a + b, 0)).toFixed(2)) / (findVal(this.x) / numAgents)).toFixed(2)})`
                                ;
                        },
                        verticalAlign: 'middle',
                        style: {

                            fontSize: '8.5px',
                            // fontFamily: 'Roboto',
                            textOutline: '0px',
                            fontWeight: 100
                        }
                    },
                }]
            }

            return (
                <div className={"barChart"} style={{ width: "220px", height: '170px', background: "transparent" }} >
                    <HighchartsReact highcharts={Highcharts} options={chartoptions} />
                </div>
            )
        }

    }


    render() {

        var selected_state = this.state.clicked_state
        var selected_state_data = {
            "State": "", "TotalAgents": 0, "YourBrand": 0, "Competitors": 0,
            "penetration": {
                Competitor_1: 0,
                Competitor_2: 0,
                Competitor_3: 0,
                YourBrand: 0
            },
            "temperature": 0
        }

        if (sessionStorage.getItem("simStarted") === "true" && this.state.data) {
            selected_state_data = this.state.data.find(state => state.State === selected_state)
        }

        var selected_zip = this.state.clicked_zip

        var selected_zip_data = { "Zip": "", "TotalAgents": 0, "YourBrand": 0, "Competitors": 0 }

        if (sessionStorage.getItem("simStarted") === "true" && this.state.data) {
            selected_zip_data = this.state.data.find(zip => zip.Zip === selected_zip)

        }

        var selected_msa = this.state.clicked_msa
        var selected_msa_data = { "MSA": "", "TotalAgents": 0, "YourBrand": 0, "Competitors": 0 }
        if (sessionStorage.getItem("simStarted") === "true" && this.state.msadata) {
            selected_msa_data = this.state.msadata.find(msa => msa.MSA === selected_msa)

        }

        var temp_msa = Math.max.apply(Math, this.state.msadata.map((o) => {
            return o[this.state.thingsToSelect[sessionStorage.getItem("tab")][this.state.selected_state]];
        }))
        var temp2 = Math.max.apply(Math, this.state.data.map((o) => {
            return o[this.state.thingsToSelect[sessionStorage.getItem("tab")][this.state.selected_state]];
        }))


        var expression_drink = ["match", ["get", "NAME10"]];
        var expression_zip = ["match", ["get", "ZCTA5CE10"]];
        var expression_msa = ["match", ["get", "cbsafp"]]


        if (temp2 > 1.20 * max_count || temp2 <= 0.8 * max_count) {
            max_count = temp2
        }

        if (temp_msa > 1.20 * max_count_msa || temp_msa <= 0.8 * max_count_msa) {
            max_count_msa = temp_msa
        }

        let zoomLevel = 0;
        // eslint-disable-next-line
        var zmlvl = 0;
        if (this.refs.map) {
            zoomLevel = this.refs.map._map.getZoom();
            zmlvl = this.refs.map._map.getZoom();
            var MaxBounds = this.refs.map._map.getBounds();
            var data = []
            var temp = {}

            if (zoomLevel >= 5) {

                temp['mapType'] = "zip"
                temp["boundaries"] = {}
                temp['boundaries']['latne'] = MaxBounds["_ne"]["lat"];
                temp['boundaries']['latsw'] = MaxBounds["_sw"]["lat"];
                temp['boundaries']['lonne'] = MaxBounds["_sw"]["lng"] + 0.6 * (MaxBounds["_ne"]["lng"] - MaxBounds["_sw"]["lng"]);
                temp['boundaries']['lonsw'] = MaxBounds["_sw"]["lng"];
                data.push(temp)
            } else {

                temp['mapType'] = "state"
                temp["boundaries"] = {}
                temp['boundaries']['latne'] = MaxBounds["_ne"]["lat"];
                temp['boundaries']['latsw'] = MaxBounds["_sw"]["lat"];
                temp['boundaries']['lonne'] = MaxBounds["_ne"]["lng"];
                temp['boundaries']['lonsw'] = MaxBounds["_sw"]["lng"];
                data.push(temp)

            }


            this.props.emit_data('map_boundaries', data);


        }

        const keyName = this.state.thingsToSelect[sessionStorage.getItem("tab")][this.state.selected_state];

        if (max_count_msa < 10) {

            this.state.msadata.forEach((row) => {
                var color;


                if (row[keyName] === 0) {
                    color = 'rgba(0,0,0,0)'
                }

                if (row[keyName] > 0 && row[keyName] <= 1) {
                    color = config[keyName].color1
                }

                if (row[keyName] > 1 && row[keyName] <= 2) {
                    color = config[keyName].color2
                }

                if (row[keyName] > 2 && row[keyName] <= 3) {
                    color = config[keyName].color3
                }

                if (row[keyName] > 3 && row[keyName] <= 4) {
                    color = config[keyName].color4
                }

                if (row[keyName] > 4 && row[keyName] <= 5) {
                    color = config[keyName].color5
                }

                if (row[keyName] > 5 && row[keyName] <= 6) {
                    color = config[keyName].color6
                }

                if (row[keyName] > 6 && row[keyName] <= 7) {
                    color = config[keyName].color7
                }

                if (row[keyName] > 7 && row[keyName] <= 8) {
                    color = config[keyName].color8
                }

                if (row[keyName] > 8 && row[keyName] <= 9) {
                    color = config[keyName].color9
                }

                if (row[keyName] >= 10) {
                    color = config[keyName].color10
                }

                expression_msa.push(row["MSA"], color);

            });

            expression_msa.push('rgba(0,0,0,0)');
        }

        if (max_count_msa > 10) {

            this.state.msadata.forEach((row) => {
                var color;

                if (row[keyName] === 0) {
                    color = 'rgba(0,0,0,0)'
                }

                if (row[keyName] > 0 && row[keyName] <= max_count_msa * 0.8) {
                    color = config[keyName].color2
                }

                if (row[keyName] > max_count_msa * 0.8 && row[keyName] <= max_count_msa * 0.85) {
                    color = config[keyName].color3
                }

                if (row[keyName] > max_count_msa * 0.85 && row[keyName] <= max_count_msa * 0.9) {
                    color = config[keyName].color4
                }

                if (row[keyName] > max_count_msa * 0.9 && row[keyName] <= max_count_msa * 0.95) {
                    color = config[keyName].color5
                }

                if (row[keyName] > max_count_msa * 0.95 && row[keyName] <= max_count_msa) {
                    color = config[keyName].color6
                }

                if (row[keyName] > max_count_msa && row[keyName] <= max_count_msa * 1.05) {
                    color = config[keyName].color7
                }

                if (row[keyName] > max_count_msa * 1.05 && row[keyName] <= max_count_msa * 1.1) {
                    color = config[keyName].color8
                }

                if (row[keyName] > max_count_msa * 1.1 && row[keyName] <= max_count_msa * 1.15) {
                    color = config[keyName].color9
                }

                if (row[keyName] > max_count_msa * 1.15 && row[keyName] <= max_count_msa * 1.2) {
                    color = config[keyName].color10
                }


                expression_msa.push(row["MSA"], color);

            });

            expression_msa.push('rgba(0,0,0,0)');

        }

        if (max_count < 10) {

            this.state.data.forEach((row) => {
                var color;

                if (row[keyName] === 0) {
                    color = 'rgba(0,0,0,0)'
                }

                if (row[keyName] > 0 && row[keyName] <= 1) {
                    color = config[keyName].color1
                }

                if (row[keyName] > 1 && row[keyName] <= 2) {
                    color = config[keyName].color2
                }

                if (row[keyName] > 2 && row[keyName] <= 3) {
                    color = config[keyName].color3
                }

                if (row[keyName] > 3 && row[keyName] <= 4) {
                    color = config[keyName].color4
                }

                if (row[keyName] > 4 && row[keyName] <= 5) {
                    color = config[keyName].color5
                }

                if (row[keyName] > 5 && row[keyName] <= 6) {
                    color = config[keyName].color6
                }

                if (row[keyName] > 6 && row[keyName] <= 7) {
                    color = config[keyName].color7
                }

                if (row[keyName] > 7 && row[keyName] <= 8) {
                    color = config[keyName].color8
                }

                if (row[keyName] > 8 && row[keyName] <= 9) {
                    color = config[keyName].color9
                }

                if (row[keyName] >= 10) {
                    color = config[keyName].color10
                }

                expression_zip.push(row["Zip"], color);

            });

            expression_zip.push('rgba(0,0,0,0)');
        }

        if (max_count < 10) {
            this.state.data.forEach((row) => {
                var color;

                if (row[keyName] === 0) {
                    color = 'rgba(0,0,0,0)'
                }

                if (row[keyName] > 0 && row[keyName] <= 1) {
                    color = config[keyName].color1
                }

                if (row[keyName] > 1 && row[keyName] <= 2) {
                    color = config[keyName].color2
                }

                if (row[keyName] > 2 && row[keyName] <= 3) {
                    color = config[keyName].color3
                }

                if (row[keyName] > 3 && row[keyName] <= 4) {
                    color = config[keyName].color4
                }

                if (row[keyName] > 4 && row[keyName] <= 5) {
                    color = config[keyName].color5
                }

                if (row[keyName] > 5 && row[keyName] <= 6) {
                    color = config[keyName].color6
                }

                if (row[keyName] > 6 && row[keyName] <= 7) {
                    color = config[keyName].color7
                }

                if (row[keyName] > 7 && row[keyName] <= 8) {
                    color = config[keyName].color8
                }

                if (row[keyName] > 8 && row[keyName] <= 9) {
                    color = config[keyName].color9
                }

                if (row[keyName] >= 10) {
                    color = config[keyName].color10
                }

                expression_drink.push(row["State"], color);

            });

            expression_drink.push('rgba(0,0,0,0)');


        }

        if (max_count > 10) {

            this.state.data.forEach((row) => {
                var color;

                if (row[keyName] === 0) {
                    color = 'rgba(0,0,0,0)'
                }

                if (row[keyName] > 0 && row[keyName] <= max_count * 0.1) {
                    color = config[keyName].color2
                }

                if (row[keyName] > max_count * 0.1 && row[keyName] <= max_count * 0.2) {
                    color = config[keyName].color3
                }

                if (row[keyName] > max_count * 0.2 && row[keyName] <= max_count * 0.3) {
                    color = config[keyName].color4
                }

                if (row[keyName] > max_count * 0.3 && row[keyName] <= max_count * 0.4) {
                    color = config[keyName].color5
                }

                if (row[keyName] > max_count * 0.4 && row[keyName] <= max_count * 0.5) {
                    color = config[keyName].color6
                }

                if (row[keyName] > max_count * 0.5 && row[keyName] <= max_count * 0.6) {
                    color = config[keyName].color7
                }

                if (row[keyName] > max_count * 0.6 && row[keyName] <= max_count * 0.7) {
                    color = config[keyName].color8
                }

                if (row[keyName] > max_count * 0.7 && row[keyName] <= max_count * 0.8) {
                    color = config[keyName].color9
                }

                if (row[keyName] > max_count * 0.8 && row[keyName] <= max_count) {
                    color = config[keyName].color10
                }


                expression_zip.push(row["Zip"], color);

            });

            expression_zip.push('rgba(0,0,0,0)');

        }

        if (max_count > 10) {

            this.state.data.forEach((row) => {
                var color;

                if (row[keyName] === 0) {
                    color = 'rgba(0,0,0,0)'
                }

                if (row[keyName] > 0 && row[keyName] <= max_count * 0.1) {
                    color = config[keyName].color2
                }

                if (row[keyName] > max_count * 0.1 && row[keyName] <= max_count * 0.2) {
                    color = config[keyName].color3
                }

                if (row[keyName] > max_count * 0.2 && row[keyName] <= max_count * 0.3) {
                    color = config[keyName].color4
                }

                if (row[keyName] > max_count * 0.3 && row[keyName] <= max_count * 0.4) {
                    color = config[keyName].color5
                }

                if (row[keyName] > max_count * 0.4 && row[keyName] <= max_count * 0.5) {
                    color = config[keyName].color6
                }

                if (row[keyName] > max_count * 0.5 && row[keyName] <= max_count * 0.6) {
                    color = config[keyName].color7
                }

                if (row[keyName] > max_count * 0.6 && row[keyName] <= max_count * 0.7) {
                    color = config[keyName].color8
                }

                if (row[keyName] > max_count * 0.7 && row[keyName] <= max_count * 0.8) {
                    color = config[keyName].color9
                }

                if (row[keyName] > max_count * 0.8 && row[keyName] <= max_count) {
                    color = config[keyName].color10
                }


                expression_drink.push(row["State"], color);

            });

            expression_drink.push('rgba(0,0,0,0)');

        }

        const { classes } = this.props;

        return (
            <div>
                <div className="CountryView" id="CountryView" ref="CountryView">
                    <ReactMapGL
                        container='Map'
                        id="maps"
                        ref="map"
                        style={{ width: "73vw", height: "77.5vh" }}
                        // transitionDuration={1000}
                        // transitionInterpolator={new FlyToInterpolator()}
                        maxZoom={this.props.maxZoom}
                        minZoom={this.props.minZoom}
                        mapStyle={this.props.mapStyle}
                        latitude={this.state.viewport.latitude}
                        longitude={this.state.viewport.longitude}
                        pitch={this.state.viewport.pitch}
                        minPitch={this.state.viewport.minPitch}
                        maxPitch={this.state.viewport.maxPitch}
                        zoom={this.state.viewport.zoom}
                        center={this.props.center}
                        // maxBounds={[[-131.74648260475695,21.029837784870537],[-59.10026091189671, 53.61038940177997]]}
                        // {...this.state.viewport}
                        onViewportChange={viewport => this.setState({ viewport, expression_drink: expression_drink })}
                        accessToken={
                            "pk.eyJ1IjoiaXJkLWV4cGVyaWVuY2VsYWIiLCJhIjoiY2p4MzV1OWNwMGU2ZjRhb2hmaGk3a3hhNiJ9.WSSPwNtURkPTyewDE5N3FQ"
                        }
                    >
                        {zmlvl = 17.5 ?

                            <Popup
                                longitude={77.738293}
                                latitude={12.982915}

                            >
                                <div><img alt={'na'} onClick={this.OpenFamily.bind(this)} width="90vw" height="90vh" src={"Icon.png"}></img> <span role="img" aria-label="">👋</span>  </div>
                            </Popup> : null
                        }


                        {zmlvl = 17.5 ?

                            <Marker
                                longitude={77.73920359532394}
                                latitude={12.98377605589465}

                            >
                                <div ref="Marker" style={{ display: 'none' }}><img alt={'na'} width="400vw" height="250vh" src={"Family.png"}></img> <span role="img" aria-label="">👋</span> </div>
                            </Marker> : null
                        }

                        <Source id='zip' type='vector' url='mapbox://ird-experiencelab.7pcfaa3f/' />

                        <Source id='msa' type='vector' url='mapbox://ird-experiencelab.bprqpgmc/' />

                        <Source id='state' type='vector' url={this.state.geourl} />

                        {this.state.selected_layer === "msa" ?
                            <div>
                                <Layer
                                    id='msalayer'
                                    minzoom={5}
                                    maxzoom={14}
                                    type='fill'
                                    source='msa'
                                    source-layer='us_msa'
                                    paint={{
                                        'fill-color': expression_msa,
                                        'fill-outline-color': '#800000',
                                        'fill-opacity': 0.8
                                    }}
                                />
                                {sessionStorage.getItem('simStarted') === 'true' && this.state.showPopupZ && selected_msa_data &&

                                    <Popup
                                        visible={this.state.showPopupZ}
                                        latitude={this.state.zpopupLatitude}
                                        longitude={this.state.zpopupLongitude}
                                        closeButton={true}
                                        closeOnClick={false}
                                        onClose={() => this.setState({ showPopupZ: false })}
                                        anchor="top">


                                        {/* <div className={"popupContent"} style={{ display: 'flex', flexDirection: 'column' }}>
                                            <div className={"popupTitle"} >
                                                <Fragment>
                                                    <div>
                                                        MSA {this.state.clicked_msa}
                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: 'felx-start', fontSize: "9px" }}>
                                                        <div style={{ margin: '0px 8px' }}>Population: {selected_msa_data.TotalAgents}</div>
                                                        <div>Units Sold: {parseInt(selected_msa_data.YourBrand + selected_msa_data.Competitors)}</div>
                                                    </div>
                                                </Fragment>
                                            </div>

                                            <div className={"graphsSection"} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', borderTop: "1px solid rgba(128, 128, 128, 0.18)" }} >
                                                {this.renderDonut(
                                                    [
                                                        ["Your Brand", Math.round(selected_msa_data.YourBrand / (selected_msa_data.YourBrand + selected_msa_data.Competitors) * 100)
                                                        ],
                                                        [
                                                            "Competitors", Math.round(selected_msa_data.Competitors / (selected_msa_data.YourBrand + selected_msa_data.Competitors) * 100)
                                                        ]]
                                                )}
                                            </div>
                                        </div> */}


                                        {this.renderDonut(
                                            [
                                                ["Your Brand", Math.round(selected_msa_data.YourBrand / (selected_msa_data.YourBrand + selected_msa_data.Competitors) * 100)
                                                ], [
                                                    "Competitors", Math.round(selected_msa_data.Competitors / (selected_msa_data.YourBrand + selected_msa_data.Competitors) * 100)
                                                ]]
                                        )}


                                        {selected_msa_data.YourBrand + selected_msa_data.Competitors > 0 ?
                                            <div style={{ textAlign: "center", fontWeight: "bold" }}>
                                                All Brands Consumption
                                            : {this.kFormatter(parseInt(selected_msa_data.YourBrand + selected_msa_data.Competitors))}
                                            </div>
                                            :
                                            null
                                        }
                                        <div style={{ textAlign: "center", fontWeight: "bold" }}>
                                            Population : {selected_msa_data.TotalAgents}
                                        </div>
                                    </Popup>


                                }

                                {sessionStorage.getItem('simStarted') === 'true' && this.state.showPopupZ && selected_msa_data === undefined && <Popup
                                    visible={this.state.showPopupZ}
                                    latitude={this.state.zpopupLatitude}
                                    longitude={this.state.zpopupLongitude}
                                    closeButton={true}
                                    closeOnClick={false}
                                    onClose={() => this.setState({ showPopupZ: false })}
                                    anchor="top" >
                                    <div style={{ height: 40, width: 100, textAlign: 'center', alignContent: 'center' }}>
                                        NO DATA AVAILABLE
                                    </div>
                                </Popup>
                                }

                            </div>
                            : null}

                        {this.state.selected_layer === 'zip' ?
                            // Add a div incase you want to include the second Zip layer
                            <div>
                                <Layer
                                    id='ziplayer'
                                    minzoom={5}
                                    maxzoom={14}
                                    type='fill'
                                    source='zip'
                                    source-layer='zcta5'
                                    paint={{
                                        'fill-color': expression_zip,
                                        'fill-outline-color': '#E37E1D',
                                        'fill-opacity': 0.8
                                    }}
                                />
                                {sessionStorage.getItem('simStarted') === 'true' && this.state.showPopupZ && selected_zip_data &&
                                    <Popup
                                        visible={this.state.showPopupZ}
                                        latitude={this.state.zpopupLatitude}
                                        longitude={this.state.zpopupLongitude}
                                        closeButton={true}
                                        closeOnClick={false}
                                        onClose={() => this.setState({ showPopupZ: false })}
                                        anchor="top">

                                        {/* <div className={"popupContent"} style={{ display: 'flex', flexDirection: 'column' }}>
                                            <div className={"popupTitle"} >
                                                <Fragment>
                                                    <div>
                                                        ZIP {this.state.clicked_zip}
                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: 'felx-start', fontSize: "8px" }}>
                                                        <div style={{ margin: '0px 8px' }}>Population: {selected_zip_data.TotalAgents}</div>
                                                        <div>Units Sold: {parseInt(selected_zip_data.YourBrand + selected_zip_data.Competitors)}</div>
                                                    </div>
                                                </Fragment>
                                            </div>

                                            <div className={"graphsSection"} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', borderTop: "1px solid rgba(128, 128, 128, 0.18)" }} >
                                                {this.renderDonut(
                                                    [
                                                        ["Your Brand", Math.round(selected_zip_data.YourBrand / (selected_zip_data.YourBrand + selected_zip_data.Competitors) * 100)
                                                        ],
                                                        [
                                                            "Competitors", Math.round(selected_zip_data.Competitors / (selected_zip_data.YourBrand + selected_zip_data.Competitors) * 100)
                                                        ]]
                                                )}
                                            </div>
                                        </div> */}


                                        {this.renderDonut(
                                            [
                                                ["Your Brand", Math.round(selected_zip_data.YourBrand / (selected_zip_data.YourBrand + selected_zip_data.Competitors) * 100)
                                                ],
                                                [
                                                    "Competitors", Math.round(selected_zip_data.Competitors / (selected_zip_data.YourBrand + selected_zip_data.Competitors) * 100)
                                                ]]
                                        )}
                                        {selected_zip_data.YourBrand + selected_zip_data.Competitors > 0 ?
                                            <div style={{ textAlign: "center", fontWeight: "bold" }}>
                                                All Brands Consumption
                                            : {this.kFormatter(parseInt(selected_zip_data.YourBrand + selected_zip_data.Competitors))}
                                            </div>
                                            :
                                            null
                                        }
                                        <div style={{ textAlign: "center", fontWeight: "bold" }}>
                                            Population : {selected_zip_data.TotalAgents}
                                        </div>
                                    </Popup>
                                }

                                {sessionStorage.getItem('simStarted') === 'true' && this.state.showPopupZ && selected_zip_data === undefined &&
                                    <Popup
                                        visible={this.state.showPopupZ}
                                        latitude={this.state.zpopupLatitude}
                                        longitude={this.state.zpopupLongitude}
                                        closeButton={true}
                                        closeOnClick={false}
                                        onClose={() => this.setState({ showPopupZ: false })}
                                        anchor="top">
                                        <div style={{ height: 40, width: 100, textAlign: 'center', alignContent: 'center' }}>
                                            NO DATA AVAILABLE
                                    </div>
                                    </Popup>
                                }

                            </div>
                            :
                            null
                        }

                        <Layer
                            id='statelayer'
                            minzoom={1}
                            maxzoom={5}
                            type='fill'
                            source='state'
                            source-layer='stategeo'
                            paint={{
                                'fill-color': expression_drink,
                                'fill-outline-color': config[keyName].color10,

                                'fill-opacity': 0.8
                            }}
                        />

                        {sessionStorage.getItem('simStarted') === 'true' && this.state.showPopup && selected_state_data &&

                            <Popup

                                visible={this.state.showPopup}
                                latitude={this.state.popupLatitude}
                                longitude={this.state.popupLongitude}
                                closeButton={true}
                                closeOnClick={false}
                                onClose={() => this.setState({ showPopup: false })}
                                anchor="top">
                                <div className={"popupContent"} style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div className={"popupTitle"} >
                                        <Fragment>
                                            <div>
                                                {this.state.clicked_state}
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'felx-start', fontSize: "11px" }}>
                                                {
                                                    selected_state_data.temperature === undefined ? null : <div>Temperature: <b>{(selected_state_data.temperature).toFixed(1)}°C </b> </div>
                                                }
                                                <div style={{ margin: '0px 8px' }}>Population: <b>{selected_state_data.TotalAgents}</b> </div>
                                                <div>All Brands Consumption: <b> {this.kFormatter(parseInt(selected_state_data.YourBrand + selected_state_data.Competitors))} </b></div>
                                            </div>
                                        </Fragment>
                                    </div>

                                    <div className={"graphsSection statePopup"} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', borderTop: "1px solid rgba(128, 128, 128, 0.18)" }} >
                                        {this.renderDonut(
                                            [
                                                ["Your Brand", Math.round(selected_state_data.YourBrand / (selected_state_data.YourBrand + selected_state_data.Competitors) * 100)
                                                ],
                                                [
                                                    "Competitors", Math.round(selected_state_data.Competitors / (selected_state_data.YourBrand + selected_state_data.Competitors) * 100)
                                                ]]
                                        )}
                                        {this.state.selected_mode === "cumulative" ? this.loadBarGraph() : null}
                                    </div>
                                </div>

                            </Popup>


                        }

                        {sessionStorage.getItem('simStarted') === 'true' && this.state.showPopup && selected_state_data === undefined &&
                            <Popup
                                visible={this.state.showPopup}
                                latitude={this.state.popupLatitude}
                                longitude={this.state.popupLongitude}
                                closeButton={true}
                                closeOnClick={false}
                                onClose={() => this.setState({ showPopup: false })}
                                anchor="top">
                                <div style={{ height: 40, width: 100, textAlign: 'center', alignContent: 'center' }}>
                                    NO DATA AVAILABLE
                            </div>
                            </Popup>
                        }


                        {/* Layer_for_MapBox_Integration */}
                        <Layer
                            id="3d-buildings"
                            source="composite"
                            source-layer="building"
                            filter={["==", "extrude", "true"]}
                            type="fill-extrusion"
                            paint={{
                                "fill-extrusion-color": "#6397B8",
                                "fill-extrusion-height": [
                                    "interpolate",
                                    ["linear"],
                                    ["zoom"],
                                    15,
                                    0,
                                    15.05,
                                    ["get", "height"]
                                ],
                                "fill-extrusion-base": [
                                    "interpolate",
                                    ["linear"],
                                    ["zoom"],
                                    15,
                                    0,
                                    15.05,
                                    ["get", "min_height"]
                                ],
                                "fill-extrusion-opacity": 0.8
                            }}
                        />
                        <NavigationControl showCompass showZoom position='top-left' />

                    </ReactMapGL>

                    <div id="reset"
                        style={!this.props.hide === true && this.props.namespace === "simulation" ? { left: "32%" } : null}>
                        <img title='Reset' alt="reset" src="reticle.svg"
                            onClick={this.resetButtonClicked.bind(this)}></img>
                    </div>


                    <div id="LegendPaper"
                        style={!this.props.hide === true && this.props.namespace === "simulation" ? { left: "38%" } : null}>
                        {
                            sessionStorage.getItem('simStarted') === "true" && this.state.isLegendOpened ? this.getLegends(classes, keyName) : null
                        }
                    </div>

                    <img
                        style={!this.props.hide === true && this.props.namespace === "simulation" ? { left: "32%" } : null}
                        alt="zoomIn" src="add.svg" onClick={this.zoomMap.bind(this, "in")} id="zoomIn"
                        title={"Zoom In"}></img>
                    <img
                        style={!this.props.hide === true && this.props.namespace === "simulation" ? { left: "32%" } : null}
                        alt="zoomOut" src="substract.svg" onClick={this.zoomMap.bind(this, "out")} id="zoomOut"
                        title={"Zoom Out"}></img>


                    {this.putMapDropdowns(zoomLevel, classes, this.props.countryWidth)}

                </div>
            </div>
        );
    }
}

export default withStyles(styles)(CountryView);
